'use strict';

import Loading from "../components/Loading";
import {getTimeRounded} from "../helpers/search";
import Tooltip from "../components/Tooltip";
import OfferDetail, { ButtonSlot, FormSlot, NotesSlot, PriceSlot, TermsSlot } from "~/components/OfferDetail";
import OfferDetailForm from "~/components/OfferDetailForm";
import ItemDetail from "~/components/search/ItemDetail";

class FlightSearchModal extends React.Component {
    
    constructor(props) {
        super(props);
        this.initState = {
            isFetching: false,
            isSubmitting: false,
            notFound: false,
            item: null,
            averagePrice: null,
            onShowBarometerClick: null,
            imageDimensions: null,
            routes: [],
            showForm: false,
            formDataInit: {},
            formData: {},
            errors: {},
        }
        this.state = this.initState;
    }

    componentDidMount() {
        
        const handleSelectOffer = (id, imageDimensions, initData = {}) => {
            this.setState({isFetching: true, errors: {}});
            flightAction.fetchSearchFlight({id, imageDimensions}).then(response => {
                this.setState({
                    isFetching: false,
                    notFound: response.item === null,
                    item: response.item,
                    routes: response.item?.routes || [],
                }, () => setFormData(initData, response.item));
            });
        }
        
        const setFormData = (initData = {}, item = {}) => {
            
            if (!initData.showForm) return;

            const formData = {}
            
            if (item && item.routes && item.routes.length > 0 && item.routes[0]) {
                if (item.routes[0].date) formData.date = item.routes[0].date
                if (item.routes[0].time) formData.time = getTimeRounded(item.routes[0].time)
                if (item.routes[0].departTime) formData.time = getTimeRounded(item.routes[0].departTime)
                if (item.routes[0].departTimeFrom) formData.time = getTimeRounded(item.routes[0].departTimeFrom)
            }

            if ((initData.routes || []).length > 0) {
                if (initData.routes[0].date) formData.date = initData.routes[0].date
                if (initData.routes[0].time) formData.time = getTimeRounded(initData.routes[0].time)
                if (initData.routes[0].seats) formData.seats = initData.routes[0].seats
            }

            if (Object.keys(formData).length > 0) {
                this.setState({formDataInit: formData})
            }
        }

        listenEvent('react.selectFlightOffer', data => {
            this.setState({
                imageDimensions: data.imageDimensions || null,
                routes: data.routes || [],
                buttons: data.buttons || [],
                showTerms: data.showTerms,
                showNotes: data.showNotes,
                showPrice: data.showPrice,
                showForm: data.showForm,

                showBarometer: data.showBarometer,
                onShowBarometerClick: data.barometer?.onShowBarometerClick || null,
                averagePrice: data.barometer?.averagePrice || null,
            });
            
            if(data.item === null) {
                this.setState(this.initState);
            } else {
                if(data.id) {
                    this.setState({imageDimensions: data.imageDimensions});
                    handleSelectOffer(data.id, data.imageDimensions, data);
                }
                if(data.item) {
                    this.setState({
                        item: data.item,
                    }, () => setFormData(data, data.item));
                }
            }
        })
    }

    getSubmitRoutes({formDatetimeFirst = false, form = {}}) {
        const {item, routes} = this.state;
        let date, time;
        return item.routes.map((flightRoute, index) => {
            const searchRoute = routes && routes[index] ? routes[index] : {};
            const from = flightRoute.from;
            const to = flightRoute.to;
            const seats = form.seats || searchRoute.seats || 1;
            const fleet_id = flightRoute.fleetId || null
            const arrive_date = flightRoute.arriveDate || null
            const arrive_time = flightRoute.arriveTime || null
            const flight_time = flightRoute.flightTimeClear || null

            if (!formDatetimeFirst) {
                date = flightRoute.departDateFrom || flightRoute.departDate || searchRoute.date;
                time = getTimeRounded(flightRoute.departTimeFrom || flightRoute.departTime || searchRoute.time);
            } else {
                date = form.date || searchRoute.date || flightRoute.departDateFrom || flightRoute.departDate;
                time = getTimeRounded(form.time || searchRoute.time || flightRoute.departTimeFrom || flightRoute.departTime);
            }
            
            return {from, to, date, time, seats, fleet_id, arrive_date, arrive_time, flight_time}
        })
    }

    handleSubmit(form) {
        
        const {item} = this.state;

        if (!checkAuth()) return;

        this.setState({isSubmitting: true});
        
        const type = this.getType(item._version, item.type)

        let data = {
            type: type,
            routes: this.getSubmitRoutes({formDatetimeFirst: type === 'emptyleg', form}),
            id: isNaN(parseInt(item.id)) ? null : item.id, // Если только цифры, тогда считается, что есть
            offerId: item.offer_id || null,
            selectedClasses: item.aircraft.class.id ? [item.aircraft.class.id] : null,
            selectedAircrafts: item.aircraft.id ? [item.aircraft.id] : null,
        };
        data = Object.fromEntries(
            Object.entries(data).filter(([key, value]) => value !== null)
        );

        if(type === 'barometer') {
            data.extId = item.ext_id;
            data.price = item.prices.price;
            data.currency = item.prices.currency.code;
            data.aircraft = {
                title: item.aircraft.title,
                year: item.aircraft.year,
            }
        }

        if (form) {
            this.setState({formDataInit: form})
            data.date = form.date;
            data.time = form.time;
            data.seats = form.seats;
        }
        
        (data.id ? requestAction.submitFlight(data) : requestAction.submitRequest(data)).then(response => {
            this.setState({isSubmitting: false});
            if (response.status === 'success') {
                $.fancybox.close();
                successPopup(type, () => {
                    $('body, html').animate({scrollTop: 0}, 500);
                    if (feature_enabled('FEATURE_HEADER_NEW')) {
                        raiseEvent('showOrdersBeard', { type: 'requests', fetch: true });
                    } else {
                        raiseEvent('toggleSideBeard', { state: { type: 'requests', tab: 'current', filter: 'all' } });
                    }
                })
            } else if(response.errors) {
                this.setState({errors: response.errors});
            }
        });
    }
    
    getType(version, type) {
        if (version == '3') return type.code;
        return type;
    }

    isPriceBelowAnnual(item) {
        if (!this.state.averagePrice || !item.prices.price || isNaN(this.state.averagePrice) || isNaN(item.prices.price)) return false;
        return item.prices.price < this.state.averagePrice
    }

    setFormData(data) {
        this.setState({formData: data});
    }
    
    render() {
        const {isFetching, isSubmitting, notFound, item, onShowBarometerClick, imageDimensions, formDataInit, formData, buttons, errors} = this.state;
        const {averagePrice} = this.state; // for old form
        const { showPrice = true, showBarometer = false, showNotes = true, showTerms = false, showForm = false } = this.state;
        const routes = item?.routes || [];

        let departDate, departDateFrom, departDateTo = null;
        if (showForm && item && routes && routes.length > 0 && routes[0]) {
            departDate = routes[0].date
            departDateFrom = routes[0].date
            departDateTo = routes[0].date_to
        }

        return <React.Fragment>
            
            <Loading active={isFetching} absolute={false}/>

            {(!isFetching && notFound) && <div style={{height: '200px'}}>
                <div className="notFound">{tMsg('Данный рейс более недоступен')}</div>
            </div>}

            {!isFetching && item && item._version === undefined && <ItemDetail 
                item={item}
                imageSize={imageDimensions}
                showForm={showForm}
                averagePrice={averagePrice}
                showPriceModal={true}
                formDataInit={formDataInit}
                errors={errors}
                isSubmitting={isSubmitting}
                onSubmit={form => this.handleSubmit(form)}
                onShowBarometerClick={onShowBarometerClick}
                buttons={buttons}
            />}

            {!isFetching && item && item._version == '3' && <OfferDetail
                item={item}
                imageSize={imageDimensions}
            >
                {!showNotes && <NotesSlot />}
                {!showTerms && <TermsSlot />}
                {!showPrice && <PriceSlot />}
                {showForm && <FormSlot>
                    <OfferDetailForm
                        departDate={departDate}
                        departDateFrom={departDateFrom}
                        departDateTo={departDateTo}
                        maxSeats={parseInt(item.aircraft.params.seats.value)}
                        errors={errors}
                        formDataInit={formDataInit}
                        onChange={data => this.setFormData(data)}
                    />
                </FormSlot>}

                {showPrice && showBarometer && this.isPriceBelowAnnual(item) && <PriceSlot>
                    <div className="offer-control__price">
                        <a type='button'
                            className="flight-price__graph-link offer-control__price-value el-tooltip"
                            data-tooltip={tMsg('Цена ниже среднегодовой')}
                            onClick={onShowBarometerClick}
                        >
                            <i className="icon-down4"></i>
                            {item.prices.prefix}{item.prices.price.formatPrice(item.prices.currency.code)}
                        </a>
                    </div>
                </PriceSlot>}

                {buttons.includes('pdf') && item.pdf && <ButtonSlot>
                    <a href={item.pdf.url} target="_blank" className="button button-white">
                        {tMsg('Предложение')} <span>(PDF)</span>
                    </a>
                </ButtonSlot>}
                {buttons.includes('submit') && <ButtonSlot>
                    <button disabled={isSubmitting} className="button button-base" onClick={() => this.handleSubmit(formData)}>
                        {tMsg('Получить предложение')}
                    </button>
                </ButtonSlot>}

            </OfferDetail>}

            <Tooltip />
            
        </React.Fragment>
    }
}

const domContainer = document.querySelector('#reactFlightSearchModal');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(FlightSearchModal));
